import React from 'react';
import { Link } from 'react-router-dom';
import Logo from 'assets/logo/logo-doku-coach-small.svg';
import { Image } from 'react-bootstrap';
import styled from 'styled-components';

import { useContextLayout } from 'components/Layout/context';

type Prop = {
  active: string;
};

const Button = styled.button<Prop>`
  && span {
    background-color: ${({ active, theme }) => (active ? theme.colors.malibu : theme.colors.ghost)};
    ::before {
      background-color: ${({ active, theme }) =>
        active ? theme.colors.malibu : theme.colors.ghost};
    }
    ::after {
      background-color: ${({ active, theme }) =>
        active ? theme.colors.malibu : theme.colors.ghost};
    }
  }
`;

const HeaderMobile = () => {
  const { menuActive, setMenuActive } = useContextLayout();
  return (
    <div className="header-mobile">
      <Link to="/">
        <Image style={{ height: '48px', width: '48px' }} src={Logo} />
      </Link>
      <div className="d-flex align-items-center">
        <Button
          active={menuActive}
          className="btn p-0 burger-icon burger-icon-left"
          onClick={() =>
            setTimeout(() => {
              !menuActive && setMenuActive('aside-on');
            }, 0)
          }
        >
          <span />
        </Button>
      </div>
    </div>
  );
};

export default HeaderMobile;
